import { render, staticRenderFns } from "./home.vue?vue&type=template&id=c4d5b15c&scoped=true"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"
import style0 from "./home.vue?vue&type=style&index=0&id=c4d5b15c&prod&lang=less"
import style1 from "./home.less?vue&type=style&index=1&id=c4d5b15c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d5b15c",
  null
  
)

export default component.exports